<template>
    <div class="content">
        <div class="hw-content">
            <div class="content-head-title">订单[{{ this.OrdersSN }}]申请开票</div>
            <div class="mb20" v-for="(item, index) in orderInfo" :key="index">
                <div v-if="item.InvoiceState == 'false'" class="error">[{{ item.Orders_SN }}]: {{ item.Message }}</div>
                <div v-if="item.InvoiceState == 'true'">
                    <el-descriptions title="" :column="2" border size="medium" labelClassName="custom-label">
                        <el-descriptions-item label="订单号">
                            <div class="rows">{{ item.Orders_SN }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="订单类型">
                            <div class="rows">{{ item.DiscountCateName }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="发票类型">
                                <div>
                                    <el-select v-model="item.Invoice_Type_List[item.itemInvoiceIndex].value" placeholder="请选择" class="el-select-medium">
                                        <el-option v-for="items in item.Invoice_Type_List" :key="items.value" :label="items.name" :value="items.value"></el-option>
                                    </el-select>
                                </div>
                            </el-descriptions-item>
                            <el-descriptions-item label="客户名称">
                                <div>{{ item.Invoice.Buyer_name }}</div>
                            </el-descriptions-item>
                            <el-descriptions-item label="税号">
                                <div>{{ item.Invoice.Buyer_tax_no }}</div>
                            </el-descriptions-item>
                            <el-descriptions-item label="地址电话">
                                <div>{{ item.Invoice.Buyer_addr_phone }}</div>
                            </el-descriptions-item>
                            <el-descriptions-item label="开户账户">
                                <div>{{ item.Invoice.Buyer_bank_accounts }}</div>
                            </el-descriptions-item>
                            <el-descriptions-item label="客户类型">
                                <div>{{ item.Invoice.typeset }}</div>
                            </el-descriptions-item>
                            <el-descriptions-item label="申请人邮箱">
                                <div>{{ item.Invoice.Apply_Email }}</div>
                            </el-descriptions-item>
                            <!-- <el-descriptions-item label="EMS Region">
                                <div>
                                    <el-input v-model="item.Message" placeholder="请输入" clearable class="el-select-medium"></el-input>
                                </div>
                            </el-descriptions-item> -->
                        <el-descriptions-item label="注释" v-if="item.InvoiceState == 'true'">
                            <div>
                                <el-input v-model="item.Invoice.Apply_remark" placeholder="请输入" clearable class="el-select-medium"></el-input>
                            <font style="color: #ff0000; margin-left: 5px" v-if="item.Invoice.Apply_remark!=''">*</font>
                            </div>
                        </el-descriptions-item>
                    </el-descriptions>
                </div>
            </div>

            <div class="button-container">
                <el-button type="primary" v-if="relate_orders.length > 0" :loading="Loading" @click="submit">已经确认客户开票信息正确无误</el-button>
                <el-button type="primary" @click="goBack">返回</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import { Loading } from 'element-ui';

export default {
    props: {
        orderOperate: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            OrdersID: '',
            OrdersSN: '', //合同SN
            OrdersAuditStatus: '', //合同审核状态
            batchId: '',
            Apply_remark:'',
            orderInfo: [],
            relate_orders: [],
            Loading: false
        };
    },
    mounted() {
        if (this.orderOperate) {
            this.OrdersID = this.orderOperate.OrdersID;
            this.OrdersSN = this.orderOperate.OrdersSN;
            this.Apply_remark="";
            this.OrdersAuditStatus = this.orderOperate.OrdersAuditStatus;
            this.batchId = this.orderOperate.batchId;
            this.CheckSPCOrdersBatchInvoice();
           
        }
    },
    methods: {
        async CheckSPCOrdersBatchInvoice() {
            let loadingInstance = this.$loading(); // 显示 loading
            let result = await this.$newsApi.order.CheckSPCOrdersBatchInvoice({
                OrdersID: this.OrdersID,
                relate_orders: this.batchId
            });
            this.$closeLoading(loadingInstance); // 关闭 loading
            const data = result.data.data.map((item) => {
                if (item.InvoiceState === 'true') {
                    this.relate_orders.push(item.Orders_ID);

                    // 直接转换 Invoice_Type 为数组对象
                    item.Invoice_Type_List = Object.keys(item.Invoice.Invoice_Type).map((key) => ({
                        name: key,
                        value: item.Invoice.Invoice_Type[key]
                    }));
                    this.Apply_remark=item.Invoice.Apply_remark;
                    
                    item.itemInvoiceIndex = 0;
                    item.itemInvoiceshow = false;
                }
                return item;
            });
            this.orderInfo = data;
        },
        goBack() {
            // this.$router.push({
            //     path: '/orderManagement/contractmanagementDetails',
            //     query: {
            //         id: this.OrdersID
            //     }
            // });
            this.$emit('BatchTicketRes', false);
        },
        async submit() {
            // 提取当前列表参数
            this.Loading = true;
            let arr = this.orderInfo;
            let json = arr.reduce((acc, item) => {
                if (item.InvoiceState === 'true') {
                    acc[`Invoice_Type_${item.Orders_ID}`] = item.Invoice_Type_List[item.itemInvoiceIndex].value || '';
                    acc[`Apply_EMSRegion_${item.Orders_ID}`] = item.Message || '';
                    acc[`Apply_remark_${item.Orders_ID}`] = item.Invoice.Apply_remark || '';
                }
                return acc;
            }, {});
            json.relate_orders = this.relate_orders.join();
            json = JSON.stringify(json);
            let result = await this.$newsApi.order.SPCOrders_InvoiceApplyAdd({
                OrdersID: this.OrdersID,
                Json: json
            });
             this.Loading = false;
            if (result.data.Resultcode == 0) {
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });
                // this.$router.go(-1);
                this.$emit('BatchTicketRes', false);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.content {
    background: #fff;
}
.hw-content {
    padding: 20px;
}

/* 通用样式 */
.rows {
    width: 389px;
}
.links {
    color: #409eff;
    cursor: pointer;
}
.red {
    color: #f56c6c;
    margin-right: 10px;
}
.distributeBox {
    /deep/.is-center,
    .el-table__cell {
        padding: 0;
    }
    /deep/.cell {
        padding: 0;
    }
}

.office-box {
    .no-border-table {
        border: none; /* 去掉表格的四周边框 */
    }

    .no-border-table .el-table__header,
    .no-border-table .el-table__body {
        border: none; /* 去掉表头和表体的边框 */
    }

    .no-border-table .el-table__row {
        border: none; /* 去掉表格行的边框 */
    }
    /deep/.is-center,
    /deep/.el-table__cell {
        height: 25px;
    }
}
.cart-list-container {
    border: 1px solid #e4e7ed;
    border-radius: 15px;
    padding: 20px 25px 10px 25px;
}
.cart-list {
    background-color: #ffffff;
    font-size: 14px;
    .cart-top {
        font-weight: 700;
        margin-bottom: 10px;
        .cart-top-title {
            .title-contetn {
                font-size: 14px;
                margin-right: 10px;
            }
        }
    }
    .cart-top-title-big {
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 10px;
    }
}
.total {
    font-size: 14px;
    text-align: right;
    margin-top: 10px;
    span {
        color: red;
        padding-right: 20px;
    }
}
.flex {
    display: flex;
    align-items: center;
}
.mb20 {
    margin-bottom: 20px;
}
.error {
    color: red;
    font-weight: 700;
    margin-bottom: 20px;
}
/* 禁用所有滚动条 */
.content,
.hw-content,
.content * {
    overflow: hidden !important;
    overflow-x: hidden !important;
    overflow-y: hidden !important;
}
.content,
.hw-content
 {
    overflow: hidden !important;
    overflow-x: hidden !important;
    overflow-y: auto !important;
}

/* 禁用弹窗滚动条 */
::v-deep .el-dialog {
    overflow: hidden !important;
   overflow-y: hidden !important;
}

::v-deep .el-dialog__body {
    overflow: hidden !important;
    overflow-y: hidden !important;
}
</style>